<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AAHI6b/media/FC-9781398489622.jpg?1697494195226" alt="This image is the cover for the book Hush"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hush
      </h1>
      <p class="bookDescription body article font2">
        <p>In the gripping novel titled Hush, the protagonist grapples with the weight of her mistakes, realizing that even the smallest misstep can have far-reaching consequences. For her, it’s not just a mere error; it has a name—a crime that threatens to cast a lifelong shadow, and worst of all, it means letting down the people she holds dear. Like a precarious row of dominoes, her entire life’s work teeters on the edge, vulnerable to the slightest nudge. The haunting fear of being unloved and becoming a source of disgrace forces her to abandon logic, plunging her into the clutches of a mysterious man who offers a dubious solution. Unaware of the profound upheaval this decision will unleash upon her existence, she embraces the man’s proposition in a desperate bid to salvage her future. Little does she know that her choice will upend her life, hurling her heart into the heart of a cyclone fuelled by tumultuous emotions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Liz Sorora
      </h2>
      
      <p class="authorDescription body article">Liz Sorora was born in a small city of Albania and was raised in a village in Greece. Liz has grown to be an education major, with psychological interests, as well as a huge passion for literature, arts and philosophy. If she isn’t spending her time writing, then you most likely will find her painting and listening to music. Creating for her is a means to reach out to someone, comfort them, embrace them and entertain them. She is a firm believer that there’re many ways individuals can learn and thus she tries to embody in her writings life lessons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25d26c88